import config from './config/distribute'
import axios from '@/utils/request'
export const distributeProductList = params => axios.post(config.distributeProductList, params)
export const distributeProductExport = params =>
  axios.post(config.distributeProductExport, params, { responseType: 'blob' })
export const distributeProductStatusUpdate = params =>
  axios.post(config.distributeProductStatusUpdate, params)
export const distributeRecordList = params => axios.post(config.distributeRecordList, params)
export const distributeRecordExport = params =>
  axios.post(config.distributeRecordExport, params, { responseType: 'blob' })
